export const ru = {
    assistant_for: 'Ассистент для:',
};
